<template>
    <div class="formAdd-content">
        <heads :title="id?'编辑表单':'新增表单'" :isShowSave="false"></heads>
        <div>
            <el-form ref="form" label-width="80px" class="submit-form" :rules="rules" :model="reqData">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item label="表单名称" prop="name">
                            <el-input v-model.trim="reqData.name" placeholder="请输入表单名称" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="提交地址" prop="submitUrl">
                            <el-input v-model.trim="reqData.submitUrl" placeholder="请输入提交地址" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <fm-making-form ref="makingform" class="making-form" :data="jsonData" :value="values">
                <template slot="action"></template>
            </fm-making-form>
            <div class="operate">
                <el-button @click="preview" class="submit-btn" size="small" type="plain">预览</el-button>
                <el-button @click="submit('form')" class="submit-btn" size="small" type="primary">提交</el-button>
            </div>
        </div>
        <!-- <el-button @click="toAddPage">去添加页面</el-button> -->
        <el-dialog :visible.sync="dialogTableVisible" width="420px" title="表单预览" class="preview-dialog">
            <div class="form-content">
                <div class="formName">{{reqData.name}}</div>
                <fm-generate-form
                        :data="showData"
                        :remote="remoteFuncs"
                        :value="showValues"
                        ref="generateForm"
                        v-if="dialogTableVisible"
                ></fm-generate-form>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="dialogTableVisible = false">确 定</el-button>
      </span>
        </el-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import heads from "@/components/header.vue";
    import api from "@/api/formMaking/index.js";

    export default {
        components: {heads},
        data() {
            return {
                optionUrl:'',
                reqData: {
                    submitUrl: "",
                    name: ""
                },
                dialogTableVisible: false,
                rules: {
                    submitUrl: [
                        {required: true, message: "请输入提交地址", trigger: "blur"}
                    ],
                    name: [{required: true, message: "请输入表单名称", trigger: "blur"}]
                },
                jsonData: {
                    list: [],
                    config: {}
                },
                showData: {},
                remoteFuncs: {},
                values: [],
                showValues: []
            };
        },
        computed: {
            id() {
                return this.$route.query.id;
            }
        },
        beforeMount(){
            this.getOptionUrl();
        },
        mounted() {
            this.initData();
        },
        methods: {
            async initData() {
                if (this.id == undefined) return;
                let res = await this.$http.get(`${api.detail}?id=${this.id}`);
                if (res && res.isSucceed) {
                    if (res.rows && res.rows.length > 0) {
                        let data = res.rows[0];
                        this.reqData.submitUrl = data.submitUrl;
                        this.reqData.name = data.name;
                        this.jsonData.list = JSON.parse(data.list);
                        this.jsonData.config = JSON.parse(data.config);
                        this.$refs.makingform.setJSON(this.jsonData);
                    }
                }
            },
            // 替换属性
            changePro(data, props) {
                for (let key in data) {
                    for (let propKey in props) {
                        if (key === propKey) continue;
                        if (key === props[propKey]) {
                            data[propKey] = data[key];
                            delete data[key];
                        }
                        if (data[key] instanceof Object) {
                            this.changePro(data[key], props);
                        }
                    }
                }
            },
            // 预览
            async preview() {
                let showData = this.$refs.makingform.getJSON();
                this.showData = showData;
                this.dialogTableVisible = true;
                for (let item of showData.list) {
                    if (item.options.remoteFunc &&!item.options.remoteFunc.startsWith("func")){
                        this.options = await this.getRemoteData(item.options.remoteFunc);
                        this.changePro(this.options, item.options.props);
                        item.options.remoteOptions = this.options;
                        this.options = [];
                    }
                }
                this.showData = showData;
            },
            // 获取远端数据
            getRemoteData(data) {
                return new Promise((resolve, reject) => {
                    axios.get(this.optionUrl+data, {
                        headers: {Authorization: this.$store.state.token, cId: this.cId}
                    })
                        .then(res => {
                            resolve(res.data);
                        })
                        .catch(error => {
                            this.dealError(error);
                            resolve();
                        });
                });
            },
            // 处理抛出错误信息
            dealError(error) {
                if (error && error.response) {
                    this.$message.error(error.response.data.message);
                    if (error.response.status === 401) {
                        this.$message.error("抱歉，你没有相关权限");
                    }
                } else {
                    this.$message.error(`当前网络不可用 请稍后重试`);
                }
            },
            async getOptionUrl(){
                let res = await this.$http.get('/pms/pms/scommunityinfo/getSwIpByCommuntiyId',{
                    params:{
                        communityId:this.$store.state.userInfo.communityId
                    }
                })
                if(res.isSucceed){
                    this.optionUrl=res.data;
                }
            },
            // 提交
            submit(formName) {
                let data = JSON.parse(JSON.stringify(this.$refs.makingform.getJSON()));
                if (!data.list || data.list.length <= 0) {
                    this.$message.error("请填写表单内容");
                    return;
                }
                this.$refs[formName].validate(async valid => {
                    if (!valid) return;
                    data.list = JSON.stringify(data.list);
                    data.config = JSON.stringify(data.config);
                    if (this.id != undefined) {
                        data.id = this.id;
                    }
                    data.submitUrl = this.reqData.submitUrl;
                    data.name = this.reqData.name;
                    let res = await this.$http.post(api.saveForm, this.$qs.stringify(data));
                    if (res && res.isSucceed) {
                        this.$router.push("/platformConfig/formMaking");
                    }
                });
            }
        }
    };
</script>
<style lang="less" scoped>
    .formAdd-content {
        background: #fff;
        height: 100%;
        // padding: 20px;
        & > div {
            height: calc(100% - 60px);
            padding: 20px;
            .making-form {
                height: calc(100% - 180px);
            }
            .submit-form {
                margin: 20px auto;
            }
            .operate {
                text-align: center;
                .submit-btn {
                    width: 100px;
                    margin-top: 20px;
                }
            }
        }
    }
</style>
<style lang="less">
    .el-dialog__wrapper {
        overflow: inherit;
    }

    .widget-config-container {
        width: 350px !important;
    }

    .fm2-container footer {
        display: none;
    }

    .preview-dialog {
        .el-dialog {
            border-radius: 10px;
        }
        .el-dialog__body {
            padding: 20px 20px 30px;
            height: 600px;
            border-bottom: 1px solid #e9eaec;
            border-top: 1px solid #e9eaec;
            overflow: auto;
            .form-content {
                .formName {
                    width: 100%;
                    text-align: center;
                    height: 40px;
                    line-height: 40px;
                    font-size: 20px;
                }
                .el-form-item__content {
                    margin-left: 0px !important;
                    width: 100%;
                }
                .el-input,
                .el-select,
                .el-cascader,
                .fm-uplaod-container {
                    text-align: center;
                    width: 100%;
                }
                .el-form-item__label {
                    text-align: left;
                    float: none;
                }
            }
        }
    }
</style>


